<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>{{getPushDetailInfo.pustType==1 ? '系统通知' : '消息通知'}}</h1>
        <span class="pull-right icon-right" @click="isHideAlert = false">删除</span>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page bg-white" style="min-height:600px">

      <div class="padding-15">
      <div>{{getPushDetailInfo.pushContent}}</div>
      </div>
      <div class="liner margin-15"></div>
      <p class="gray margin-x-15 text-right font-14">{{getPushDetailInfo.pushDateString}}</p>

      <div class="margin-15">
        <span class="margin-15 gray">孩子信息</span>
        <div class="liner"></div>
        <ul class="list-group-item tinny">
        <li class="list-group">
          <div class="clearfix  group-txt">
            <span class="pull-left">姓名</span>
            <span class="pull-right gray">{{kidsDetail.invstudentName}}</span>
          </div>
          <div class="liner"></div>
        </li>
        <li class="list-group">
          <div class="clearfix  group-txt">
            <span class="pull-left">性别：</span>
            <span class="pull-right gray">{{kidsDetail.sex}}</span>
          </div>
          <div class="liner"></div>
        </li>
        <li class="list-group">
          <div class="clearfix group-txt">
            <span class="pull-left">生日:</span>
            <span class="pull-right gray">{{kidsDetail.birthdayString}}</span>
          </div>
          <div class="liner"></div>
        </li>
        <li class="list-group">
          <div href="#" class="clearfix group-txt">
            <span class="pull-left">学校:</span>
            <span class="pull-right gray">{{kidsDetail.szxx}}</span>
          </div>
          <div class="liner"></div>
        </li>
        <li class="list-group">
          <div class="clearfix group-txt">
            <span class="pull-left">年级:</span>
            <span class="pull-right gray">{{kidsDetail.grade}}</span>
          </div>
          <div class="liner"></div>
        </li>
        <li class="list-group">
          <div class="clearfix group-txt">
            <span class="pull-left">班级:</span>
            <span class="pull-right gray">{{kidsDetail.className}}</span>
          </div>
          <div class="liner"></div>
        </li>
      </ul>
      </div>

      <div class="margin-15 padding-15 text-center" v-if="getPushDetailInfo.isAgree == 0">
        <span class="button-pill-circle" @click="agreeParentsMsg()">同意</span>
      </div>
      <div class="text-center" v-if='getPushDetailInfo.isAgree == 1'>
          <span class="padding-15">已同意申请</span>
      </div>
    </div>
    <div class="maskdiv" v-show="!isHideAlert" @click="isHideAlert = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap text-center">
          <p class="padding-15">您确定要删除本条消息吗？</p>
          <div class="liner margin-15"></div>
          <div class="clearfix">
            <div class="col-xs-6 blue"><a class="blue  block" style="border-right:1px solid #ddd;" @click.prevent="deletePushMsg()">是</a></div>
            <div class="col-xs-6 blue"><a class="blue" @click.prevent="isHideAlert = true">不是</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_push_list_para: service.setPara('getPushList'),
      update_push_para: service.setPara('updatePush'),
      delete_push_para: service.setPara('deletePush'),
      get_broadcast_list_para: service.setPara('getBroadCastList'),
      update_broadcast_para: service.setPara('updateBroadCast'),
      delete_broadcast_para: service.setPara('deleteBroadCast'),
      invite_StudentList_para: service.setPara('inviteStudentList'),
      agree_Parents_para: service.setPara('agreeParents'),
      get_Push_Detail_para: service.setPara('getPushDetail'),
      pushId: 0,
      getPushInfo: [],
      getBroadcastInfo: [],
      getPushDetailInfo: {},
      detailInfo: {},
      kidsDetail: {},
      agreeDetail: {},
      pushIdArray: [],
      broadCastArray: [],
      isHideAlert: true,
      teacherId: 0,
      inviteId: 0
    }
  },
  mounted: function () {
    this.pushId = this.$route.params.pushId
    // this.getPushListMsg()
    // 这是获得广播消息
    // this.getBroadCastMsg()
    this.getPushDetailMsg()
  },
  methods: {
    ...mapMutations([
      'clearStudents',
      'clearStudentParents'
    ]),
    getPushListMsg: function () {
      this.get_push_list_para.curcheId = this.login_data[this.cookie_login_data.index].curcheId
      this.get_push_list_para.userId = this.login_data[this.cookie_login_data.index].teacherId

      let that = this
      let obj = {context: this, para: this.get_push_list_para, successFun: (response) => {
        that.getPushInfo = response.data
        for (var i = 0; i < that.getPushInfo.length; i++) {
          if (that.getPushInfo[i].pushId == that.pushId) {
            that.detailInfo = that.getPushInfo[i]
            that.inviteId = that.detailInfo.inviteId
            that.inviteStudentListMsg()
            if (that.detailInfo.isRead == 0) {
              that.updatePushMsg()
            }
          }
        }
      }}
      service.request(obj)
    },
    getPushDetailMsg: function () {
      this.get_Push_Detail_para.curcheId = this.login_data[this.cookie_login_data.index].curcheId
      this.get_Push_Detail_para.teacherId = this.login_data[this.cookie_login_data.index].teacherId
      this.get_Push_Detail_para.pushId = this.pushId

      let that = this
      let obj = {context: this, para: this.get_Push_Detail_para, successFun: (response) => {
        that.getPushDetailInfo = response.data
        that.inviteId = that.getPushDetailInfo.inviteId
        that.inviteStudentListMsg()
        if (that.getPushDetailInfo.isRead == 0) {
          that.updatePushMsg()
        }
      }}
      service.request(obj)
    },
    updatePushMsg: function () {
      this.pushIdArray.push(this.getPushDetailInfo.pushId)
      this.update_push_para.pushIdList = this.pushIdArray

      let obj = {context: this, para: this.update_push_para, successFun: (response) => {

      }}
      service.request(obj)
    },
    deletePushMsg: function () {
      if (this.getPushDetailInfo.pushType == 0) {
        this.delete_push_para.pushId = this.getPushDetailInfo.pushId

        let obj = {context: this, para: this.delete_push_para, successFun: (response) => {
          window.history.go(-1) // 返回
        }}
        service.request(obj)
      }
      if (this.getPushDetailInfo.pushType == 1) {
        this.delete_broadcast_para.pushIdList = this.getPushDetailInfo.pushId
        this.delete_broadcast_para.relationId = this.getPushDetailInfo.relationId
        this.delete_broadcast_para.userId = this.login_data[this.cookie_login_data.index].teacherId

        let obj = {context: this, para: this.delete_broadcast_para, successFun: (response) => {
          Toast('删除成功')
          window.history.go(-1) // 返回
        }}
        service.request(obj)
      }
    },
    getBroadCastMsg: function () {
      this.get_broadcast_list_para.curcheId = this.login_data[this.cookie_login_data.index].curcheId
      this.get_broadcast_list_para.userId = this.login_data[this.cookie_login_data.index].teacherId

      let that = this
      let obj = {context: this, para: this.get_broadcast_list_para, successFun: (response) => {
        that.getBroadcastInfo = response.data
        for (var i = 0; i < that.getBroadcastInfo.length; i++) {
          if (that.getBroadcastInfo[i].pushId == that.pushId) {
            that.detailInfo = that.getBroadcastInfo[i]
            that.detailInfo.relationId
            if (that.detailInfo.field1 == 0) {
              that.updateBroadcasthMsg()
            }
          }
        }
      }}
      service.request(obj)
    },
    inviteStudentListMsg: function () {
      this.invite_StudentList_para.inviteId = this.inviteId

      let that = this
      let obj = {context: this, para: this.invite_StudentList_para, successFun: (response) => {
        that.kidsDetail = response.data
      }}
      service.request(obj)
    },
    agreeParentsMsg: function () {
      // inviteId 为进入详情页所获得的id
      this.agree_Parents_para.inviteId = this.inviteId

      let that = this
      let obj = {context: this, para: this.agree_Parents_para, successFun: (response) => {
        that.getPushDetailInfo.isAgree = 1
        that.agreeDetail = response.data
        this.$store.dispatch('clearStudents') // 更新学生数据
        this.$store.dispatch('clearStudentParents')
      }}
      service.request(obj)
    },
    updateBroadcasthMsg: function () {
      // this.broadCastArray.push(this.detailInfo.pushId)
      this.update_broadcast_para.pushIdList = this.getPushDetailInfo.pushId
      this.update_broadcast_para.userId = this.login_data[this.cookie_login_data.index].teacherId
      this.update_broadcast_para.relationId = this.getPushDetailInfo.relationId

      let obj = {context: this, para: this.update_broadcast_para, successFun: (response) => {

      }}
      service.request(obj)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// NewsDetailInvitation.vue?57861348